import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TerminologyComponent } from './terminology/terminology.component';

const routes: Routes = 
[
  { path:"", component: TerminologyComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TerminologyRoutingModule { }
